/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscordRelayHistoryMessageItem } from './DiscordRelayHistoryMessageItem';
import {
    DiscordRelayHistoryMessageItemFromJSON,
    DiscordRelayHistoryMessageItemFromJSONTyped,
    DiscordRelayHistoryMessageItemToJSON,
    DiscordRelayHistoryMessageItemToJSONTyped,
} from './DiscordRelayHistoryMessageItem';

/**
 * 
 * @export
 * @interface DiscordRelayMessageHistoryBody
 */
export interface DiscordRelayMessageHistoryBody {
    /**
     * Socket ID of the client to send history to
     * @type {string}
     * @memberof DiscordRelayMessageHistoryBody
     */
    socketId: string;
    /**
     * Discord channel ID
     * @type {string}
     * @memberof DiscordRelayMessageHistoryBody
     */
    channelId: string;
    /**
     * Array of historical messages
     * @type {Array<DiscordRelayHistoryMessageItem>}
     * @memberof DiscordRelayMessageHistoryBody
     */
    messages: Array<DiscordRelayHistoryMessageItem>;
    /**
     * Bot authentication token
     * @type {string}
     * @memberof DiscordRelayMessageHistoryBody
     */
    botToken: string;
}

/**
 * Check if a given object implements the DiscordRelayMessageHistoryBody interface.
 */
export function instanceOfDiscordRelayMessageHistoryBody(value: object): value is DiscordRelayMessageHistoryBody {
    if (!('socketId' in value) || value['socketId'] === undefined) return false;
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('botToken' in value) || value['botToken'] === undefined) return false;
    return true;
}

export function DiscordRelayMessageHistoryBodyFromJSON(json: any): DiscordRelayMessageHistoryBody {
    return DiscordRelayMessageHistoryBodyFromJSONTyped(json, false);
}

export function DiscordRelayMessageHistoryBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayMessageHistoryBody {
    if (json == null) {
        return json;
    }
    return {
        
        'socketId': json['socketId'],
        'channelId': json['channelId'],
        'messages': ((json['messages'] as Array<any>).map(DiscordRelayHistoryMessageItemFromJSON)),
        'botToken': json['botToken'],
    };
}

export function DiscordRelayMessageHistoryBodyToJSON(json: any): DiscordRelayMessageHistoryBody {
    return DiscordRelayMessageHistoryBodyToJSONTyped(json, false);
}

export function DiscordRelayMessageHistoryBodyToJSONTyped(value?: DiscordRelayMessageHistoryBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'socketId': value['socketId'],
        'channelId': value['channelId'],
        'messages': ((value['messages'] as Array<any>).map(DiscordRelayHistoryMessageItemToJSON)),
        'botToken': value['botToken'],
    };
}

